module.exports = __webpack_public_path__ + "img/7_Fenntarthato_fejlodesi_celok.0feff0f6.jpg";